import { NUMERIC_REGEX } from './regexes';

export function toIndianCurrencyString(
  amount: number,
  withoutSign: boolean = false,
  fractionDigits: number = 0,
) {
  return `${!withoutSign ? '₹' : ''}${amount.toLocaleString('en-IN', {
    minimumFractionDigits: fractionDigits,
  })}`;
}

export function getNumberFromIndianCurrencyString(amount: string) {
  return +amount.replace(/ |₹|,/g, '');
}

let id = 0;

export const uniqueId = () => {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substring(2);
  return dateString + randomness + id++;
};

export const isNumeric = (value: string | undefined) => {
  if (value) {
    const regex = new RegExp(NUMERIC_REGEX);
    return regex.test(value);
  }
  return true;
};

export const rupeeAmountToPaise = (amount: number = 0) => {
  return amount * 100.0;
};

export const paiseAmountToRupee = (amount: number = 0) => {
  return amount / 100.0;
};

export const percentageToBps = (percentage: number = 0) => {
  return Math.round(percentage * 10000);
};

export const bpsToPercentage = (bps: number = 0) => {
  return bps / 10000;
};

// Returns the number with its ordinal suffix appended, e.g. 1 -> "1st", 2 -> "2nd",
// 11 -> "11th", 23 -> "23rd". The 11/12/13 carve-out is the standard English exception.
export const ordinalSuffix = (n: number): string => {
  if (n >= 11 && n <= 13) return `${n}th`;
  const mod = n % 10;
  if (mod === 1) return `${n}st`;
  if (mod === 2) return `${n}nd`;
  if (mod === 3) return `${n}rd`;
  return `${n}th`;
};

